"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MENU_CATEGORY_ID_FOR_PREVIEW = void 0;
exports.MENU_CATEGORY_ID_FOR_PREVIEW = 'b05b3ec1-8ace-4bc0-9a7b-a241bf64a708';
//# sourceMappingURL=index.js.map